var React = require('react');

function LogoIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M28.8555 25.5684L15.474 33.5455C13.298 34.8464 10.4916 34.322 8.92564 32.3353L2.79414 24.5095L2.60094 24.6205C-0.103834 26.0928 -0.835953 29.6124 1.05535 32.0227L8.92564 42.0773C10.4814 44.064 13.2878 44.5884 15.474 43.2874L29.5572 34.8969C32.4246 33.1925 32.8314 29.2393 30.3808 26.9904L28.8454 25.5785L28.8555 25.5684Z","fill":"#424548","key":0}),React.createElement("path",{"d":"M30.3806 9.88642L21.0766 1.32442C19.4903 -0.127794 17.1414 -0.420253 15.2501 0.618482L2.61089 7.51649C-0.0938855 8.98887 -0.826005 12.5085 1.0653 14.9187L8.93559 24.9733C10.4913 26.96 13.2978 27.4844 15.484 26.1835L29.5671 17.7929C32.4346 16.0886 32.8413 12.1353 30.3907 9.88642H30.3806Z","fill":"#424548","key":1})]);
}

LogoIcon.defaultProps = {"width":"32","height":"44","viewBox":"0 0 32 44","fill":"none"};

module.exports = LogoIcon;

LogoIcon.default = LogoIcon;
